<form [formGroup]="form">
  <h4 class="fw-bold my-4">Filtra richieste</h4>
  <div class="row g-2 pe-1">
    <div class="col-6">
      <label class="form-label" for="nomeRisorsa">Risorsa</label>
      <input
        type="text"
        id="nomeRisorsa"
        formControlName="nomeRisorsa"
        class="form-control"
        maxlength="50"
      />
    </div>
    <div class="col-6">
      <label class="form-label" for="risorsa">Matricola</label>
      <input
        type="text"
        id="risorsa"
        formControlName="risorsa"
        class="form-control"
        maxlength="50"
      />
    </div>
    <div class="col-12">
      <label class="form-label" for="commessaSorgente">Commessa sorgente</label>
      <app-autocomplete
        [_formControl]="commessaSorgente"
        [_list]="commesse"
        [fullTitle]="true"
      ></app-autocomplete>
    </div>
    <div class="col-12">
      <label class="form-label" for="commessaDestinazione"
        >Commessa destinazione</label
      >
      <app-autocomplete
        [_formControl]="commessaDestinazione"
        [_list]="commesse"
        [fullTitle]="true"
      ></app-autocomplete>
    </div>
    @if ([attori.ControllerCentrale].includes(attore)) {
      <div class="col-6">
      <label class="form-label" for="descrizioneUnitaOrganizzativaPrimoLivello">
        Unità Organizzativa Primo Livello
      </label>
      <select formControlName="descrizioneUnitaOrganizzativaPrimoLivello" class="form-select">
        <option [ngValue]="null">-</option>
        <option *ngFor="let unita of uoPrimoLivello" [ngValue]="unita.descrizione">
          {{ unita.descrizione }}
        </option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label" for="nomeApprovatore">Utente approvatore</label>
      <input
        type="text"
        id="nomeApprovatore"
        formControlName="nomeApprovatore"
        class="form-control"
        maxlength="50"
      />
    </div>
    }
    <div class="col-6">
      <label class="form-label" for="dataApprovazione">
        Data approvazione
      </label>
      <input type="date" id="dataApprovazione" formControlName="dataApprovazione" class="form-control"
        maxlength="50" />
    </div>
    <div class="col-12 d-flex justify-content-end mt-4 mb-4">
      <button
        (click)="search(true)"
        type="button"
        class="btn btn-outline-primary fw-semibold me-2"
      >
        Reset
      </button>
      <button
        (click)="search()"
        type="submit"
        class="btn btn-primary fw-semibold"
      >
        Cerca
      </button>
    </div>
  </div>
</form>
